export default __webpack_public_path__ + "static/media/Wonderstick.efc1df80.png";